import { useQuery } from '@tanstack/react-query';

import * as sessionAuditApi from './session-audit.api';

import type { SessionAuditListQuery } from '@utazzo/shared';

/** Admin-only session/auth audit list. Query key carries the full filter set. */
export const useSessionAudit = (query: SessionAuditListQuery) =>
  useQuery({
    queryKey: ['session-audit', 'list', query],
    queryFn: () => sessionAuditApi.listSessionAudit(query),
    staleTime: 15_000,
  });
